import { AfterViewInit, Component, DestroyRef, OnInit, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationError, Router } from "@angular/router";
import { AlertV2Component } from "./shared/alert-v2/alert-v2.component";
import { CommonService } from "./shared/common.service";
import { RealtimeStartupCoordinatorService } from "./shared/collaboration/realtime-startup-coordinator.service";
import { ThemeService } from "./shared/services/theme.service";
import { AppVersionService } from "./shared/app-version.service";
import { BootCoordinatorService } from "./shared/boot/boot-coordinator.service";
@Component({
  standalone: false,
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild("alert") alert?: AlertV2Component;
  title = "SBest";
  constructor(
    public commonService: CommonService,
    public realtimeCoordinator: RealtimeStartupCoordinatorService,
    public appVersionService: AppVersionService,
    public bootCoordinator: BootCoordinatorService,
    private themeService: ThemeService,
    router: Router,
    destroyRef: DestroyRef,
  ) {
    router.events.pipe(takeUntilDestroyed(destroyRef)).subscribe((event) => {
      if (event instanceof NavigationError) {
        this.appVersionService.handleModuleLoadError(event.error);
      }
    });
  }
  ngOnInit() {
    this.bootCoordinator.start();
  }
  enablePushNotifications(): void {
    void this.realtimeCoordinator.ensurePushReady();
  }
  ngAfterViewInit(): void {
    this.commonService.alertRef$.next(this.alert);
    this.bootCoordinator.markShellVisible();
  }

  retryVersionUpdate(): void {
    void this.appVersionService.refreshAppVersion().catch(() => undefined);
  }
}
